export const getHorizontalAlign = (style, direction) => {
  if (direction) {
    if (direction === "column") {
      if (style === "left") return "items-start";
      if (style === "center") return "items-center";
      if (style === "right") return "items-end";
    }
  }

  if (style === "left") return "justify-start text-left";
  if (style === "center") return "justify-center text-center";
  if (style === "right") return "justify-end text-right";
  if (style === "between") return "justify-between text-left";

  return "justify-start text-left";
};

export const getVerticalAlign = (style, direction) => {
  if (direction) {
    if (direction === "column") {
      if (style === "top") return "justify-start text-left";
      if (style === "center") return "justify-center text-center";
      if (style === "bottom") return "justify-end text-end";
    }
  }

  if (style === "top") return "items-start";
  if (style === "center") return "items-center";
  if (style === "bottom") return "items-end";

  return "items-start";
};

export const getFlexDirection = (style) => {
  switch (style) {
    case "row":
      return "flex-row";

    case "column":
      return "flex-col";

    default:
      return "flex-col";
  }
};
